module.exports = __webpack_public_path__ + "static/img/clubSocial1.5ec2c29a.jpg";